import { FunctionComponent, useContext } from 'react';

import { CtaTypes } from 'models/Article';;

import LocaleContext from 'components/context/Locale';
import SectionContact from 'components/modules/public/layout/sections/Contact';
import SectionProduct from 'components/modules/public/pages/Product/sections/Product';

import { Props } from './index';
import StyledComponent from './styles';

// TODO: MID - Use dynamic imports
const PublicBlogsArticleCta: FunctionComponent<Props> = ({ article }) => {
    const localeContext = useContext(LocaleContext);
    if (!article?.ctaType) return null;

    const product = article?.ctaTypeData?.product;
    const productTranslations = localeContext?.translations?.product;
    const contactTranslations = localeContext?.translations?.contact;

    const callToActionRender = () => {
        switch (true) {
            case article.ctaType === CtaTypes.ContactForm:
                return (
                    <SectionContact
                        translations={undefined}
                        contactTranslations={contactTranslations.content?.contact?.contactForm}
                    />
                );
            case article.ctaType === CtaTypes.LeadForm:
                return (
                    <SectionContact
                        translations={contactTranslations?.content?.contact?.contactForm}
                        gender={article?.gender}
                    />
                );
            case (article.ctaType === CtaTypes.Product && Boolean(article.ctaTypeData)):
                return (
                    <SectionProduct
                        {...productTranslations?.content?.product}
                        product={product}
                    />
                );
            default:
                return null;
        }
    };


    return (
        <StyledComponent className="public-blog-article-cta">
            {callToActionRender()}
        </StyledComponent>
    );
};

export default PublicBlogsArticleCta;
